/* Mobile product-card swipe progress bar (collection pages).
   Moved out of snippets/product-card.liquid on 2026-09-16, where it was inlined
   once per card (2,317 bytes each). It already self-guarded at runtime via
   window.__cstCardSwipeActive, but the source was still repeated in the HTML for
   every card. Loaded once, deferred, on collection templates only. */
    (function () {
      if (window.__cstCardSwipeActive) return;
      window.__cstCardSwipeActive = true;

      function isEnabled() {
        return window.innerWidth < 1000;
      }

      function initCardSwipe(card) {
        if (card.hasAttribute('data-swipe-ready')) return;
        card.setAttribute('data-swipe-ready', '');

        var media = card.querySelector('.product-card__media');
        var indicator = card.querySelector('[data-card-progress-indicator]');
        if (!media || !indicator) return;

        var ticking = false;

        function updateProgress() {
          ticking = false;
          if (!isEnabled()) return;
          var maxScroll = media.scrollWidth - media.clientWidth;
          if (maxScroll <= 0) return;
          var progress = media.scrollLeft / maxScroll;
          indicator.style.transform = 'translateX(' + (progress * 100) + '%)';
        }

        media.addEventListener('scroll', function () {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(updateProgress);
          }
        }, { passive: true });
      }

      function initAll() {
        var section = document.querySelector('.shopify-section--main-collection');
        if (!section) return;
        section.querySelectorAll('product-card:not([data-swipe-ready])').forEach(initCardSwipe);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
      } else {
        initAll();
      }

      /* Re-init on AJAX navigation (collection filtering, pagination) */
      var debounce;
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (
              node.tagName === 'PRODUCT-CARD' ||
              (node.querySelector && node.querySelector('product-card'))
            ) {
              clearTimeout(debounce);
              debounce = setTimeout(initAll, 150);
              return;
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    })();
